$(document).ready(function() {


  $("#Details-menu-drawer-container").on("click", function() {
    var attr = $(this).attr('open'); 
    $('#smile-ui-lite-launcher-frame-container').hide();
    $('.smile-improved-mobile-launcher').hide();
    
   if (typeof attr !== 'undefined' && attr !== false) {
     $('#smile-ui-lite-launcher-frame-container').show();
      $('.smile-improved-mobile-launcher').show();
     
   }
  });
  

    var selectedValue = $(".product-form__input--pill input[type='radio']:checked").val();

    var selectedImage = $(".thumbnail-list li:first-child").attr('data-variant');
    var image_1 = $('.thumbnail-list__item[data-variant="' + selectedValue + '"]');
    var mainImg = $('.product__media-item.is-active').attr("data-img");

  // console.log(selectedValue, selectedImage)
    if (selectedValue === selectedImage) {
        image_1.siblings().hide();
        image_1.show();
    }

    // Delegated handler: bound on document (never replaced) instead of the
    // radio inputs themselves. Dawn's <product-info> re-renders the
    // variant-selects markup (fresh DOM nodes) on every variant change via
    // HTMLUpdateUtility.viewTransition(), which destroys any listeners bound
    // directly to the old radio inputs. Delegation re-matches the selector
    // against whichever radios exist in the DOM at click time, so this keeps
    // working after every re-render, not just the first one.
    $(document).on('change', ".product-form__input--pill input[type='radio']", function() {
        let
            variant_id = this.value,
            variant_image = $('.thumbnail-list__item[data-variant="' + variant_id + '"]');
          console.log( variant_id, variant_image)
        variant_image.show()
        variant_image.first().children(".thumbnail").addClass("active-thumb");
        //get all single div except the one which we need to show hide it
        $(".thumbnail-list__item").not(variant_image).hide();
    });

    var CartBtnValue = $(".card__information .cart_btn_sec .cart_btn span").text();
    var availableVariant = $(".select__select option").attr('data-available');

    $(".card-wrapper.ubbs_pouches .radio_btn input[type='radio']").change(function() {
        var getInputRadioParent = $(this).parents(".radio_btn");
        var Basketbtn = $(this).parents(".card-information").find(".cart_btn_sec .cart_btn span")
      //   var MediaImg1 = $(this).parents(".card--media").find(".card__media .prod_img_sec .media-1");
      //   var MediaImg2 = $(this).parents(".card--media").find(".card__media .prod_img_sec .media-2");
      // var MediaImg3 = $(this).parents(".card--media").find(".card__media .prod_img_sec .media-3");

        if ($(getInputRadioParent).find("input[type='radio']:checked").attr('data-available') == 'true') {
            Basketbtn.text("Add To Basket");
        } else if ($(getInputRadioParent).find("input[type='radio']:checked").attr('data-available') == 'false') {
            Basketbtn.text("Out of Stock");
        }


        var selectedMedia = $(this).attr("data-media"); 

        $(this).parents(".card--media").find(".card__media .prod_img_sec img").each(function () {
            var altText = $(this).attr("alt");

            if (altText === selectedMedia) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });


        // if ($(getInputRadioParent).find("input[type='radio']:checked").attr('value') == '6mg') {
        //     MediaImg2.hide();
        //     MediaImg1.show();
        //    MediaImg3.hide();
        // } else if ($(getInputRadioParent).find("input[type='radio']:checked").attr('value') == '11mg') {
        //     MediaImg2.show();
        //     MediaImg1.hide();
        //   MediaImg3.hide();
        // } else if ($(getInputRadioParent).find("input[type='radio']:checked").attr('value') == '14mg'){
        //   MediaImg3.show();
        //     MediaImg1.hide();
        //   MediaImg2.hide();
        // } else if ($(getInputRadioParent).find("input[type='radio']:checked").attr('value') == '20mg'){
        //   MediaImg3.show();
        //     MediaImg1.hide();
        //   MediaImg2.hide();
        // }

    });

      //dropdown on  click of account icon starts here //
  $('.account_sec a').click(function(){
    $('.account_sec #login-sec').delay(100).slideDown();
	
  });
  $('html').click(function(){
  if( $('.account_sec #login-sec').is(':visible') ) {
      $('.account_sec #login-sec').slideUp();
  }
  });

  //dropdown on  click of account icon ends here //
  $(window).on('load', function() {
    $(".pro_slider").slick({
      dots: true,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: '<img class="left-arrow" src="https://cdn.shopify.com/s/files/1/0559/7075/8753/files/left_arrow.png?v=1696511384" width="34" height="70">',
      nextArrow: '<img class="right-arrow" src="https://cdn.shopify.com/s/files/1/0559/7075/8753/files/right_arrow.png?v=1696511384" width="34" height="70">',
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  });

  $('.blog_slider').slick({
            infinite: false,
            arrows: true,
      prevArrow: '<button class="slide-arrow slider_left"><img class="left-arrow" src="https://cdn.shopify.com/s/files/1/0559/7075/8753/files/arrow_left.png?v=1657105561" alt="Left arrow icon | UBBS Pouches - 2" width="34" height="70"></button>',
    nextArrow: '<button class="slide-arrow right_left"><img class="right-arrow" src="https://cdn.shopify.com/s/files/1/0559/7075/8753/files/arrow_right.png?v=1657105561" alt="Right arrow icon | UBBS Pouches - 2" width="34" height="70"></button>',
            dots: false,
    		autoplay: false,
            slidesToShow: 3,
            slidesToScroll: 1,
      		rows:0,
            responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows:true,
          prevArrow: '<button class="slide-arrow slider_left"><img class="left-arrow" src="https://cdn.shopify.com/s/files/1/0559/7075/8753/files/arrow_left.png?v=1657105561" width="34" height="70"></button>',
          nextArrow: '<button class="slide-arrow right_left"><img class="right-arrow" src="https://cdn.shopify.com/s/files/1/0559/7075/8753/files/arrow_right.png?v=1657105561" width="34" height="70"></button>',
            
        },
      },
      {
        breakpoint: 767,
        settings: "unslick"
      },
    ],
        });

   $('.step-slider').slick({
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    speed: 300,
    slidesToShow: 1
  });
    
  $('.responsive1').slick({
    dots: false,
      arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow:'<button type="button" class="slick-prev pull-left"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#cccccc" class="w-6 h-6"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" /></svg></button>',
    nextArrow: "<button type='button' class='slick-next pull-right'><svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"#cccccc\" class=\"w-6 h-6\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8.25 4.5l7.5 7.5-7.5 7.5\" /></svg></button>",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          arrows: true,
          prevArrow:'<button type="button" class="slick-prev pull-left"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#cccccc" class="w-6 h-6"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" /></svg></button>',
    nextArrow: "<button type='button' class='slick-next pull-right'><svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"#cccccc\" class=\"w-6 h-6\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8.25 4.5l7.5 7.5-7.5 7.5\" /></svg></button>",

          
          }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
          arrows: true,
          prevArrow:'<button type="button" class="slick-prev pull-left"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#cccccc" class="w-6 h-6"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" /></svg></button>',
          nextArrow: "<button type='button' class='slick-next pull-right'><svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"#cccccc\" class=\"w-6 h-6\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8.25 4.5l7.5 7.5-7.5 7.5\" /></svg></button>",

          
          }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });


  
  $(".image_with_text_slider").slick({
    arrows: true,
    prevArrow: '<img class="left-arrow" src="https://cdn.shopify.com/s/files/1/0559/7075/8753/files/left_arrow.png?v=1696511384" alt="Left arrow icon | UBBS Pouches" width="34" height="70">',
    nextArrow: '<img class="right-arrow" src="https://cdn.shopify.com/s/files/1/0559/7075/8753/files/right_arrow.png?v=1696511384" alt="Right arrow icon | UBBS Pouches" width="34" height="70">',
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    autoplay: true,
   autoplaySpeed: 5000
  });
  
      $(".page-wholesale .faq_accordion .faq_header4").click(function () {
    var isFaqActive = $(this).hasClass('faq_active_bg');
      console.lo
    var getFaqParent = $(this).parents('.faq_questions_answer');

    if (isFaqActive) {
       getFaqParent.find('.faq_content').slideUp();
       $(this).removeClass('faq_active_bg');
    } else {
       getFaqParent.find('.faq_content').slideUp();
       $(this).next(".faq_content").slideDown();
       $(".faq_section .faq_header4").removeClass('faq_active_bg');
       $(this).addClass('faq_active_bg');
    }
  });
  
  var winW = $(window).outerWidth();
  if (winW < 989) {
  
   $(".heading-sec > h2").on("click", function() {
                if ($(this).hasClass("active")) {
                    $(this).removeClass("active");
                    $(this)
                        .siblings(".footer_content")
                        .slideUp(200);
                    $(".heading-sec > h2 span")
                        .removeClass("down_arrow")
                        .addClass("down_arrow");
                } else {
                    $(".heading-sec > h2 span")
                        .removeClass("down_arrow")
                        .addClass("down_arrow");
                    $(this)
                        .find("span")
                        .removeClass("down_arrow")
                        .addClass("down_arrow");
                    $(".heading-sec > h2").removeClass("active");
                    $(this).addClass("active");
                    $(".footer_content").slideUp(200);
                    $(this)
                        .siblings(".footer_content")
                        .slideDown(200);
                }
            });
  }
  
  $(".menu-drawer__menu-item span").on("click", function() {
                if ($(this).hasClass("active")) {
                    $(this).removeClass("active");
                    $(this).parent()
                        .siblings(".menu-drawer__submenu")
                        .slideUp(200);
                    $(".menu-drawer__menu-item span > i")
                        .removeClass("minus_icon")
                        .addClass("plus_icon");
                } else {
                    $(".menu-drawer__menu-item span > i")
                        .removeClass("minus_icon")
                        .addClass("plus_icon");
                    $(this)
                        .find("i")
                        .removeClass("plus_icon")
                        .addClass("minus_icon");
                    $(".menu-drawer__menu-item span").removeClass("active");
                    $(this).addClass("active");
                    $(".menu-drawer__submenu").slideUp(200);
                    $(this).parent()
                        .siblings(".menu-drawer__submenu")
                        .slideDown(200);
                }
            });


  ScrollOut({
    targets: ".viewportY_Animation",
    cssProps: {
      viewportY: true,
    },
  });

  ScrollOut({
    targets: ".fadeInUp",
    once: true,
  });
  
  ScrollOut({
      targets: ".fadeInUp",
      once: true,
    });

    if (winW < 991) {
      $(".announcement-bar").slick({
        dots: false,
        infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
        arrows: false
  });
     
   }

   $(".shop-slider").on('scroll', function() {
        $val = $(this).scrollLeft();

        if ($(this).scrollLeft() + $(this).innerWidth() >= $(this)[0].scrollWidth) {
            $(".nav-next").hide();
        } else {
            $(".nav-next").show();
        }

        if ($val == 0) {
            $(".nav-prev").hide();
        } else {
            $(".nav-prev").show();
        }
    });
    console.log('init-scroll: ' + $(".nav-next").scrollLeft());
    $(".nav-next").on("click", function() {
        $(this).parent().animate({
            scrollLeft: '+=460'
        }, 200);

    });
    $(".nav-prev").on("click", function() {
        $(this).parent().animate({
            scrollLeft: '-=460'
        }, 200);
    });
  
  
 $(".circle-orbit-container").each(function () {
    $(this).append(`
                <div class="orbit1">
                  <div class="orbit1-cirlces"></div>
                </div>
                <div class="orbit2">
                  <div class="orbit2-cirlces"></div>
                </div>
                <div class="orbit3">
                  <div class="orbit3-cirlces"></div>
                </div>
                <div class="orbit4">
                  <div class="orbit4-cirlces"></div>
                </div>
    `);
  });
  
  
  // let brandColorArray = [
  //     "watermelon",
  //     "berry",
  //     "menthol",
  //     "peppermint",
  //     "spearmint",
  //   ];
  //   //get random color from the brandColorArray
  //   let brandColor =
  //     brandColorArray[Math.floor(Math.random() * brandColorArray.length)];
  //   // =========================banner random color script starts=========================
  //   $("#banner_section .bi_title").addClass(`color_${brandColor}`);
  //   $(`#banner_section .bi_title img`).removeClass("active");
  //   $(`#banner_section .bi_title .${brandColor}`).addClass("active");
  //   // =========================banner random color script ends=========================
  
  
  
     

  $(".contain .tab-contain").hide();
         $(".contain .tab-contain:first-child").show();

         $(".tabs ul li").click(function () {
            $("ul li").removeClass("active");
            $(this).addClass("active");

            $(".contain .tab-contain").hide();
            $($(this).attr("data-list")).show();
         });

         $(".accordion .header4").click(function () {
            var isActive = $(this).hasClass('active_bg');
            var getParent = $(this).parents('.questions_answer');

            if (isActive) {
               getParent.find('.content').slideUp();
               $(this).removeClass('active_bg');
            } else {
               getParent.find('.content').slideUp();
               $(this).next(".content").slideDown();
               $(".accordion .header4").removeClass('active_bg');
               $(this).addClass('active_bg');
            }
         });



   $(function() {
  var list = $('.js-dropdown-list');
  var link = $('.js-link');
  link.click(function(e) {
    e.preventDefault();
    list.slideToggle(200);
  });
  list.find('li').click(function() {
    var text = $(this).html();
    var icon = '<i class="fa fa-chevron-down"></i>';
    link.html(text+icon);
    list.slideToggle(200);
    if (text === '* Reset') {
      link.html('Select one option'+icon);
    }
  });
});




  
});